var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckupIconG(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833008,
    width: 20.0008,
    height: 20,
    rx: 10,
    fill: "#D8F5CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83301 6L6.83301 6.66667M6.83301 6.66667L4.83301 12.6667C6.01469 13.5556 7.65212 13.5556 8.8338 12.6667M6.83301 6.66667L8.83305 12.6667M6.83301 6.66667L10.833 5.33333M14.833 6.66667L16.833 6M14.833 6.66667L12.833 12.6667C14.0147 13.5556 15.6521 13.5556 16.8338 12.6667M14.833 6.66667L16.833 12.6667M14.833 6.66667L10.833 5.33333M10.833 4V5.33333M10.833 16V5.33333M10.833 16H8.83301M10.833 16H12.833",
    stroke: "#4A9D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckupIconG);
export default __webpack_public_path__ + "static/media/checkupIconG.6cd56999536348ec7bad82b21bea770b.svg";
export { ForwardRef as ReactComponent };